import { v4 as uuidv4 } from 'uuid'

import { Section } from '../../draggable/types'

const toeReportStructure = [
  {
    name: 'Summary',
    chapters: [
      'Parties to this Agreement',
      'Purpose of this Agreement'
    ]
  },
  {
    name: 'Agency & Valuer Information',
    chapters: [
      'Identification and Status of the Valuer',
      'Valuer Certification and Quality Assurance',
      'Professional Indemnity Insurance',
      'Limitations on Liability',
      'Statement of Independence'
    ]
  },
  {
    name: 'Standards, Sources & Uses',
    chapters: [
      'Valuation Standards',
      'RICS Monitoring',
      'Nature and Source of Information',
      'Restrictions on Use, Distribution, and Publication of the Report'
    ]
  },
  {
    name: 'Property Details & Valuations',
    chapters: [
      'VPGA 10 - Material Valuation Uncertainty',
      'ESG Reporting Requirements',
      'Target Property Details'
    ]
  },
  {
    name: 'Conflict of Interest',
    chapters: [
      'COI Introduction',
      'COI Checklist',
      'Disclosures'
    ]
  },
  {
    name: 'Deliveries, Fees & Conditions',
    chapters: [
      'Delivery Details',
      'Summary',
      'Details',
      'Payment Terms'
    ]
  },
  {
    name: 'Signatures of the Parties',
    chapters: [
      'Governing Law',
      'Responding to Subpoenas or Other Judicial Requests to Produce Documents',
      'Signatures',
      'Disclaimer & Complaints Handling Procedure'
    ]
  },
  {
    name: 'Appendices',
    chapters: []
  }
]

export const defaultSections: Section[] = toeReportStructure.map(item => {
  return {
    id: uuidv4(),
    name: item.name,
    defaultName: item.name,
    included: true,
    chapters: item.chapters.map(name => {
      return {
        id: uuidv4(),
        name: name,
        defaultName: name,
        included: true
      }
    })
  }
})